import React, { useEffect, useState } from 'react';
import liracrypt from '../components/Liracrypt/liracrypt';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { message, Radio } from 'antd';
import digitalFactoryLogo from "../images/DigitalFactory.png";

import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';
import PhantomSpecial from './PhantomSpecial';
const ZenTabDynamic = ({
    api = "/textapi",
    urlData
}) => {
    const { search } = useLocation();
    const [tabs, setTabs] = useState();
    const searchParams = queryString.parse(search);
    const [loading, setLoading] = useState(true);
    const [respLoading, setRespLoading] = useState(false);
    const [selectedTab, setSelectedTab] = useState('');
    const changeTab = (e) => {
        setRespLoading(true);
        setSelectedTab(e.target.value);
        setTimeout(() => {
            setRespLoading(false);
        }, 200);
    }

    const getData = () => {
        liracrypt.get(api, { ...searchParams, ...urlData })
            .then(({ data }) => {
                if (data.isSuccess) {
                    setTabs(data);
                    setSelectedTab(data.data.find(x => x.isDefault === true)?.val)
                    setLoading(false);
                } else {
                    message.error(data.message || 'Something went wrong');
                }
            }).catch(err => {
                ApiErrorComp();
                console.log(err);
            })
    }
    useEffect(() => {
        setLoading(true);
        getData();
    }, []);

    const getSelectedTab = () => {
        let sTab = tabs?.data.find(x => x.val === selectedTab);
        return sTab
    }

    return (
        <div>
            <div
                style={{
                    display: "inline-flex",
                    padding: 10,
                    flexWrap: 'wrap',
                    alignContent: "center",
                    alignItems: "center",
                    justifyContent: "space-around",
                    width: "100%",
                }}
            >
                <div
                    className="logo"
                    style={{
                        margingLeft: 14,
                        padding: 10,
                    }}
                >
                    <img src={digitalFactoryLogo} alt="sarex" width="80" />
                </div>
                {/* <div

                style={{
                    margingLeft: 150,
                    padding: 10,
                    color: "#bdc3c7",
                    textAlign: "center",
                    fontSize: "40px",
                    fontWeight: 600,


                }}
            >
                {'Test Page'}
            </div> */}
                <Radio.Group
                    className="managerTabs ps-tabs"
                    value={"small"}
                    onChange={changeTab}>
                    {
                        tabs?.data?.length ?
                            tabs?.data.map((x, i) => (
                                <Radio.Button
                                    className={`${selectedTab === x.val ? "pharos-active-tab" : ""}`}
                                    style={{
                                        background: "#021622",
                                        padding: 10,
                                        marginBottom: 10,
                                        border: "2px solid #021826",
                                        color: x.color,
                                        textAlign: "center",
                                        fontSize: "17px",
                                        fontWeight: 600,
                                        maxWidth: "200px",
                                    }}
                                    value={x.val}>{x.label}</Radio.Button>
                            )) : <></>
                    }
                </Radio.Group>
            </div>
            {
                respLoading ?
                    <p>Loading...</p> :
                    selectedTab ?
                        <PhantomSpecial respTyp={getSelectedTab()?.resp} urlData={{ ...getSelectedTab()?.params }} api={getSelectedTab()?.api} /> : <></>
            }
        </div>
    )
};

export default ZenTabDynamic;